import React, { useState } from 'react';
import { Stack, Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import MailRecord from '../dataObjects/MailRecord';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import EditIcon from '@mui/icons-material/Edit';
interface Props {
    mailRecords: MailRecord[];
    editMailRecord: (mail: MailRecord) => void;
    deleteMailRecord: (id:number) => void
}

const NonFilerAGReferralTable = (props: Props): JSX.Element => {

    return (
        <>
            <TableContainer>
                <Table stickyHeader size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell><Typography variant='body1' fontWeight={550}>Date</Typography></TableCell>
                            <TableCell><Typography variant='body1' fontWeight={550}>Mail Description</Typography></TableCell>
                            <TableCell><Typography variant='body1' fontWeight={550}>Recipients</Typography></TableCell>
                            <TableCell><Typography variant='body1' fontWeight={550}># of Mails Sent</Typography></TableCell>
                            <TableCell><Typography variant='body1' fontWeight={550}>File</Typography></TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.mailRecords && props.mailRecords.map((mail: MailRecord) =>
                            <TableRow key={mail.id}>
                                <TableCell>
                                    <Typography variant="body1">{mail.date}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body1">{mail.description}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body1">
                                        {mail.recipientsDescription}
                                    </Typography>
                                 </TableCell>
                                <TableCell width={'10%'}>
                                    <Typography variant="body1">{mail.mailsCount}</Typography>
                                </TableCell>
                                <TableCell width={'10%'}>
                                    {
                                        mail.fileName &&
                                        <Typography variant="body1"><Link href={`https://ocpf.blob.core.windows.net/municipal-mails/${mail.fileName}`} target="_blank" underline="none">View File</Link></Typography>
                                    }
                                </TableCell>
                                <TableCell>
                                    <Stack direction="row" spacing={1} >
                                        <EditIcon className="is-clickable" color="primary" onClick={() => props.editMailRecord(mail)} ></EditIcon>
                                        <DeleteOutlinedIcon className="is-clickable" color="error" onClick={() => props.deleteMailRecord(mail.id)} />
                                    </Stack>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )

}

export default NonFilerAGReferralTable;